module.exports = __webpack_public_path__ + "img/dashboard.8f35d20d.png";